import { Controller } from 'stimulus';
import tippy, { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';

// Use this controller rather than .tooltips class to survive turbolinks js re-render
export default class extends Controller {
  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  initialize() {
    const title = this.element.title || this.element.dataset.title;

    // tooltip options
    const isScrollable = this.element.dataset.tooltipScrollable !== undefined;
    const isHtml = this.element.dataset.tooltipHtml !== undefined;
    const innerContent = isHtml ? title : this.escapeHtml(title);
    const content = isScrollable
      ? `<div style="max-height: 200px; overflow-y: auto; white-space: pre-wrap;">${innerContent}</div>`
      : title;

    const options = {
      content: content,
      animation: 'scale-subtle',
      allowHTML: true,
      theme: 'light-border',
      appendTo: () => document.body,
    };

    if (isScrollable) {
      options.interactive = true;
      options.maxWidth = 400;
    }

    const pluginType = this.element.dataset.tooltipPlugin;
    if (pluginType !== undefined) {
      options.followCursor = pluginType;
      options.plugins = [followCursor];
    }

    this.element.removeAttribute('title');
    if (title !== undefined && title.length > 1 && window.innerWidth > 1024) {
      tippy(this.element, options);
    }
  }
}
